// Google Analytics event tracking utility

// Track page views
export const trackPageView = (page) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'page_view', {
      page_path: page,
      page_title: document.title
    });
  }
};

// Track user registration
export const trackRegistration = (method) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'sign_up', {
      method: method // 'email' or 'google'
    });
  }
};

// Track login
export const trackLogin = (method) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'login', {
      method: method // 'email' or 'google'
    });
  }
};

// Track password reset
export const trackPasswordReset = (step) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'password_reset', {
      step: step // 'request' or 'complete'
    });
  }
};

// Track profile updates
export const trackProfileUpdate = (type) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'profile_update', {
      update_type: type // 'personal', 'email', 'password'
    });
  }
};

// Track wishlist interactions
export const trackWishlistAction = (action) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'wishlist_interaction', {
      action: action // 'add', 'edit', 'delete'
    });
  }
};

// Track subscription events
export const trackSubscriptionEvent = (event) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'subscription_event', {
      event_type: event // 'start_trial', 'upgrade', 'cancel'
    });
  }
}; 